/**
 * Status eines Geburtstagstermins zu dem ein Mitarbeiter angegeben hat dass er verfügbar ist.
 */
export enum BirthdayStaffAvailableStatus {
   /**
    * Termin ist verfügbar und kann gebucht werden.
    */
   open = "open",

   /**
    * Buchungsanfrage vom Kunden erhalten für den Termin, aber noch nicht bestätigt. Termin ist nicht mehr uneingeschränkt verfügbar.
    */
   reserved = "reserved",

   /**
    * Termin wurde gebucht und ist nicht mehr verfügbar.
    */
   booked = "booked"
}